import script from "./EditArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditArticle.vue?vue&type=script&setup=true&lang=ts"

import "./EditArticle.vue?vue&type=style&index=0&id=1e79530b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e79530b"]])

export default __exports__